<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/useAuthStore';
import { isTrustedRedirect } from '@/functions/trustedRedirect';

const router = useRouter();
const authStore = useAuthStore();

onMounted(async () => {
  const hash = window.location.hash.slice(1);
  if (!hash) { router.replace('/login'); return; }

  const params = new URLSearchParams(hash);
  const token = params.get('token');
  if (!token) { router.replace('/login'); return; }

  const scopesStr = params.get('scopes') || '';
  authStore.setAuthData({
    token,
    refreshToken: params.get('refresh') || '',
    email: params.get('email') || '',
    name: params.get('name') || '',
    firstname: params.get('firstname') || '',
    nickname: params.get('nickname') || '',
    profile_picture: params.get('profile_picture') || '',
    role: '',
    scopes: scopesStr ? scopesStr.split(',').filter(Boolean) : [],
    userId: params.get('userId') ? Number(params.get('userId')) : undefined,
  });

  const nextPath = params.get('next') || '';
  params.delete('next');

  history.replaceState(null, '', window.location.pathname);

  if (nextPath.startsWith('/') && !nextPath.startsWith('//')) {
    router.replace(nextPath);
    return;
  }

  if (/^https?:\/\//i.test(nextPath) && await isTrustedRedirect(nextPath)) {
    // Connexion Google initiée depuis un partenaire (Badarts, CMER, LSEF...) : la session
    // DartsHub vient d'être établie ci-dessus, on relaie maintenant le même fragment de
    // tokens vers le partenaire (moins "next", qui n'a servi qu'à cette étape).
    window.location.href = `${nextPath}#${params.toString()}`;
    return;
  }

  if (authStore.isSuperAdmin) {
    router.replace('/admin/users');
  } else {
    router.replace('/profile');
  }
});
</script>

<template>
  <div class="callback-loader">
    <i class="fa-solid fa-spinner fa-spin" />
    <span>Connexion en cours…</span>
  </div>
</template>

<style scoped>
.callback-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1rem;
  color: var(--text-muted, #64748b);
  font-size: 1.1rem;
}
</style>
